import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrganizations,
  deleteOrganization,
  changeActiveStatus,
} from "./organizationSlice";
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from "../../components/commonTable";
import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";
// import BlogAdd from './BlogAdd';
// import BlogEdit from './BlogEdit';
// import BlogView from './BlogView';

const OrganizationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { organizations } = useSelector((state) => state.organizations);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  // const [showModal, setShowModal] = useState(false);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState("");
  // const [showEditModal, setShowEditModal] = useState(false);
  //   const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(organizations?.total_records / limit);
  const total = organizations?.total_records || 0;

  const token = localStorage.getItem("admin-auth-token");
  console.log("all data", organizations);

  let organizationMessage = localStorage.getItem("organization_notify_message");

  useEffect(() => {
    if (organizationMessage) {
      setSnackbarMessage(organizationMessage);
      setSnackbarVariant("success");
      setShowSnackbar(true);
      localStorage.removeItem("organization_notify_message");
    }
  }, [organizationMessage]);

  useEffect(() => {
    const fetchOrganizations = async () => {
      setLoading(true);
      const payload = {
        page: currentPage,
        search: searchTerm,
        limit: limit,
        token,
      };

      try {
        if (token) {
          await dispatch(getOrganizations({ payload }));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching organizations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, [dispatch, token, currentPage, searchTerm, setLoading]);

  const columns = [
    { label: "Logo", key: "logo", type: "image" },
    { label: "Company", key: "company_name" },
    // { label: 'User Name', key: 'user.name' },
    { label: "Contact Person", key: "ceo_name" },
    { label: "Email", key: "user.email" },
    { label: "Mobile Number", key: "phone_number" },
    // { label: 'Tag', key: 'tag.name' },
    { label: "created On", key: "created_at", type: "date" },
    { label: "Expired On", key: "plan_end_date", type: "date" },
    { label: "Status", key: "is_active", type: "status" },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
  };

  const handleDeleteNew = async () => {
    if (selectedOrganizationId) {
      await dispatch(deleteOrganization(selectedOrganizationId)).then((res) => {
        if (res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token,
          };
          dispatch(getOrganizations({ payload }));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    localStorage.setItem("selected-organization-data", JSON.stringify(row));
    // setSelectedOrganizationId(row.id);
    // navigate(`/organization-edit/${row.id}`);
    navigate(`/organization/${row.id}`);
    // handleOpen();
  };

  //   const handleOpen = () => {
  //     setTimeout(() => {
  //       setShowEditModal(true);
  //     }, 1000);
  //   };

  const handleDelete = (row) => {
    setSelectedOrganizationId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedOrganizationId(row.id);
    // setShowViewModal(true);
  };

  const handleStatusChange = async (row) => {
    setSelectedOrganizationId(row.id);
    setShowStatusModal(true);
  };

  const handleStatusChangeNew = async () => {
    await dispatch(changeActiveStatus(selectedOrganizationId)).then((res) => {
      if (res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          page: currentPage,
          search: searchTerm,
          limit: limit,
          token,
        };
        dispatch(getOrganizations({ payload }));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  };

  return (
    <>
      <Container fluid className="px-0">
        {/* <BlogAdd 
          show={showModal}
          // onHide={() => setShowModal(false)}
          handleClose={() => setShowModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <BlogEdit
          blogId={selectedOrganizationId}
          show={showEditModal}
          // onHide={() => setShowEditModal(false)}
          handleClose={() => setShowEditModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <BlogView
          show={showViewModal}
          handleClose={() => setShowViewModal(false)}
          blogId={selectedOrganizationId} 
        /> */}

        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this organization?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change status?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowStatusModal(false)}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search Organization"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="shadow-none base-search"
          />

          <CommonButton
            icon={
              <Add01Icon
                width={16}
                height={16}
                color="#ffffff"
                strokeWidth="2"
              />
            }
            title="Add Organization"
            className="btn-primary common-one-shadow"
            onClick={() => {
              // setShowModal(true);
              navigate("/organization-add");
            }}
          />
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
          <CommonTable
            columns={columns}
            data={organizations?.data || []}
            url={organizations?.url || []}
            showActions={true}
            actions={{
              showEdit: true,
              showDelete: true,
              showView: false,
              onEdit: handleEdit,
              onDelete: handleDelete,
              onView: handleView,
            }}
            onStatusChange={handleStatusChange}
          />
        </div>

        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {limit * (currentPage - 1) + 1} to{" "}
            {Math.min(limit * currentPage, total)} of {total} Organizations
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default OrganizationList;
